import { Component, OnDestroy, OnInit } from '@angular/core';
import { Sensor, excludedSensorTypes, IValue, ApplianceTypes } from 'src/app/models/sensor';
import { Router, ActivatedRoute } from '@angular/router';
import { Zone } from 'src/app/models/zone';
import { Appliance } from 'src/app/models/appliance';
import { DataService } from 'src/app/services/data.service';
import { SocketIoService } from 'src/app/services/socket-io.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ZoneService } from '../../../services/zone.service';
import { ApiService } from "src/app/services/api.service";
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth.service';
import { UpdateDialogComponent } from '../../clients/update-dialog/update-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AddDialogComponent } from'../../clients/add-dialog/add-dialog.component';
import { DeleteDialogComponent } from '../../clients/delete-dialog/delete-dialog.component';

export interface Category {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-cycles',
  templateUrl: './cycles.component.html',
  styleUrls: ['./cycles.component.less']
})
export class CyclesComponent implements OnInit, OnDestroy {
  cycles: any | null = null;
  filteredCycles: any | null = null;
  filterMode: string = 'all'
  currentCompany: any = null
  currentCompanyId: string | null = null
  zones: Zone[] | null = null;
  growCycleCount = {
    week: {} as number,
    day: {} as number
  }
  companySettingsCycleTimes: any | null = null;
  
  subscription: Subscription;
  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private socketService: SocketIoService,
    private zoneService: ZoneService,
    private _api: ApiService,
    public authService: AuthService,
    public dialog: MatDialog,) {

      this.dataService.sharedCompany$.subscribe(company => {
        this.currentCompany = company;
      })

      this.dataService.sharedCompanyId$.subscribe(companyId => {
        this.currentCompanyId = companyId;
      })
  }

  ngOnInit(): void {
    this.getCycles();
  }

  getCycles(){
    let zones = []
    let list = JSON.parse(localStorage.getItem('zoneList'));
    zones = list.map(zone => {
      return zone._id
    })
    this._api.post<any>(`/cycles`, {zones: zones}).subscribe(resp => {
        this.cycles = resp.cycles;
        this.cycles.forEach(cycle=>{
          cycle.dates.start = moment(cycle.dates.start).format('MMMM Do YYYY, h:mm:ss a')
          if(cycle.dates.end){
            cycle.dates.end = moment(cycle.dates.end).format('MMMM Do YYYY, h:mm:ss a')
          }
          if(cycle.currentState.state !== 'End'){
            let dt1 = new Date(cycle.currentState.dates.start)
            var diff = (new Date().getTime() - dt1.getTime()) / 1000;
            let weekDiff = Math.abs(Math.round(diff / (60 * 60 * 24 * 7)));
            let dayDiff = Math.abs(Math.round(diff / (60 * 60 * 24)));
            cycle.dates.growCycleCountWeek= weekDiff + 1;
            cycle.dates.growCycleCountDay = dayDiff + 1;
          }
        })
        this.filterCycles(this.filterMode)
    }, err => {
        alert(err.message);
    });
  }

  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }

  updateCurrentZone(zone: Zone) {
    this.dataService.updateZone(zone);
  }

  addNew(type: string){
    let title = type[0].toUpperCase() + type.slice(1)
    let data: any = {
        type: type,
        company: this.currentCompanyId,
        title: title,
        name: '',
        function: (item) => this.add(type, item)
      }
    
    if(type === 'sensor' || type === 'cycle'){
        data = {...data, zone: this.zones}
    }
    
    const dialogRef = this.dialog.open(AddDialogComponent, {
        disableClose: true,
        data: data
        
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result === undefined) return;
        setTimeout(() => result.name);
        this.getCycles();
      });
  }

  add(type: string, data: any) {
      if(type === 'cycle'){
          return this._api.post<any>(`/zone/${data.zone}/${type}`,
          {
            strainName: data.name,
            state: data.currentState,            
            grow: {plantsQuantity: data.plantsQuantity},                        
            cycleTimes: data.cycleTimes,
            isAllSensors: data.isAllSensors,
            sensors: data.sensors,
            harvest: data.harvest ? data.harvest : {}
          });
      }
      return this._api.post<any>(`/${type}`, data);
  }

  editCycle(cycle){
    const dialogRef = this.dialog.open(UpdateDialogComponent, {
      disableClose: true,
      data: {
        type: 'cycle',
        title: 'Cycle',
        name: cycle,
        function: (cycle) => this.updateCycle('cycle', cycle)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;
      setTimeout(() => cycle.name = result.name);
      this.getCycles();
    });
  }

  updateCycle(type: string, cycle: any) {
    let state: any = { state: cycle.data.name.currentState.state }
    if (cycle.name.currentState.state === 'Custom') {
      state = { state: cycle.data.customState}
    }
    if(cycle.name.zoneName._id){
      state = {...state, zone: cycle.name.zoneName._id}
    }
    if(cycle.data.name.grow.plantsQuantity){
      state = {...state, plantsQuantity: cycle.data.name.grow.plantsQuantity}
    }

    if(cycle.data.name.cycleTimes){
      state = {...state, cycleTimes: cycle.data.name.cycleTimes}
    }
    if(cycle.data.name.currentState.sensors){
      state = {...state, sensors: cycle.data.name.currentState.sensors, isAllSensors: cycle.data.name.isAllSensors}
    }
    return this._api.put<any>(`/zone/${cycle.name.zoneName._id}/cycle/${cycle.data.name.id}`, state);
  }

  endCycle(cycle){
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      disableClose: true,
      data: {
        type: 'end',
        title: 'Cycle',
        name: cycle.name,
        id:cycle._id,
        zone: cycle.zone,
        function: (cycle) => this.endOptions(cycle)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;
      setTimeout(() => cycle.name = result.name);
      this.getCycles();
    });
  }

  endOptions(cycle: any) {
    return this.zoneService.updateCycle(cycle.zone, cycle.id, { state: null })
  }


  deleteCycle(cycle){
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      disableClose: true,
      data: {
        type: 'cycle',
        title: 'Cycle',
        name: cycle.name,
        id:cycle._id,
        function: (cycle) => this.deleteOptions(cycle)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;
      setTimeout(() => cycle.name = result.name);
      this.getCycles();
    });
  }

  deleteOptions(cycle: any) {
    return this.zoneService.dalateCycle(cycle.zone, cycle.id)
  }

  filterCycles(filter){
    this.filterMode = filter
    if(filter === 'all'){
      this.filteredCycles = this.cycles
    }
    if(filter === 'active'){
      this.filteredCycles = this.cycles.filter(cycle => cycle.currentState.state !== 'End')
    }
    if(filter === 'inactive'){
      this.filteredCycles = this.cycles.filter(cycle => cycle.currentState.state === 'End')
    }
  }

  DefaultCycleSettings(){
    this._api.get<any>(`/company/${this.currentCompanyId}`).subscribe(resp => {
      this.companySettingsCycleTimes = resp.data.company.settings.cycleTimes
      this.editDefaultCycleSettings(this.companySettingsCycleTimes)
    }, err => {
        alert(err.message);
    });
  }

  editDefaultCycleSettings(cycleSettings){
    const dialogRef = this.dialog.open(UpdateDialogComponent, {
      disableClose: true,
      data: {
        type: 'cycleSettings',
        title: 'Cycle Settings',
        name: {cycleTimes: cycleSettings},
        function: (cycleSettings) => this.updateDefaultCycleSettings('cycleSettings', cycleSettings)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;
      setTimeout(() => cycleSettings.name = result.name);
      this.getCycles();
    });
  }

  updateDefaultCycleSettings(type: string, cycleSettings: any) {
    let data = {settings: cycleSettings.name}
    return this._api.put<any>(`/company/${this.currentCompanyId}`, data);
  }

}
